var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import React from 'react';
import { SvgCircleIcon } from '../elements/svg-circle-icon';
export var RequiredIcon = function (props) {
  return React.createElement(SvgCircleIcon, __assign({}, props, {
    glyphWidth: 56,
    glyphHeight: 56
  }), React.createElement("path", {
    d: "M28.4512 0.76416C30.6603 0.76416 32.4512 2.55502 32.4512 4.76416V19.1069L42.5938 8.96436L42.7422 8.82275C44.3123 7.4043 46.7367 7.45148 48.25 8.96436C49.7632 10.4775 49.8109 12.9019 48.3926 14.4722L48.25 14.6216L38.1074 24.7642H52.4512C54.6603 24.7642 56.4512 26.555 56.4512 28.7642C56.451 30.9732 54.6602 32.7642 52.4512 32.7642H38.1084L48.25 42.9058C49.8121 44.4679 49.8121 47.0009 48.25 48.563C46.6879 50.1248 44.1558 50.1248 42.5938 48.563L32.4512 38.4204V52.7642L32.4463 52.9702C32.3389 55.0835 30.5911 56.7642 28.4512 56.7642C26.3113 56.7641 24.5634 55.0835 24.4561 52.9702L24.4512 52.7642V38.4204L14.3096 48.563C12.7475 50.125 10.2145 50.125 8.65234 48.563C7.09025 47.0009 7.09025 44.4679 8.65234 42.9058L18.7939 32.7642H4.45117L4.24512 32.7593C2.13186 32.652 0.451302 30.904 0.451172 28.7642C0.451172 26.6242 2.13179 24.8763 4.24512 24.769L4.45117 24.7642H18.7949L8.65234 14.6216L8.50977 14.4722C7.09164 12.902 7.13942 10.4784 8.65234 8.96533C10.1656 7.4521 12.5899 7.40419 14.1602 8.82275L14.3096 8.96533L24.4512 19.1069V4.76416C24.4512 2.55506 26.2421 0.764226 28.4512 0.76416Z",
    fill: "black"
  }));
};
export var RequiredIconGlyph = function (props) {
  return React.createElement(RequiredIcon, __assign({}, props, {
    variant: 'glyph'
  }));
};